import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { fetchBanners, Banner } from '@robocorp/robocloud-ui-utils';

const getBannersQueryKey = () => ['banners'];
const BANNER_DISPLAY_TARGET = 'control-room';

export const useBannersQuery = (
  options?: UseQueryOptions<Banner[] | undefined, Error, Banner[], string[]>,
) =>
  useQuery(
    getBannersQueryKey(),
    async () =>
      fetchBanners({
        url: import.meta.env.VITE_BANNERS_URL,
        targets: [BANNER_DISPLAY_TARGET],
      }),
    options,
  );
